import React from 'react';
import RetmonLogoDark from "../../images/logo/retmon-logo-dark.svg"
import * as S from './styled';
const Logo = () => {
  return <S.Logo
   src={RetmonLogoDark} alt="Retmon Logo Dark" />;
};

export default Logo;
